// extracted by mini-css-extract-plugin
export default {"grid":"Events_grid__n+nnZ"};